import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class NautikoWSScannerService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Vérification du service scanner.
     */
    health(scanner) {
        const url = `${scanner.url}/api/health`;
        return this.httpClient.get(url).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Numérisation d'un document.
     */
    scan(scanner, scannerId) {
        const url = `${scanner.url}/api/scanners/id/` +
            `${encodeURIComponent(scannerId)}/scan`;
        return this.httpClient.post(url, null).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération du document numérisé.
     */
    getScan(scanner, scanId) {
        const url = `${scanner.url}/api/scans/${scanId}`;
        return this.httpClient.get(url, {
            responseType: 'blob'
        }).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Suppression du document temporaire numérisé.
     */
    deleteScan(scanner, scanId) {
        const url = `${scanner.url}/api/scans/${scanId}`;
        return this.httpClient.delete(url).pipe(catchError(this.handleErrorObservable));
    }
    handleErrorObservable(error) {
        throw error;
    }
    getScanners(scanner) {
        const url = `${scanner.url}/api/scanners`;
        return this.httpClient.get(url).pipe(catchError(this.handleErrorObservable));
    }
}
NautikoWSScannerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NautikoWSScannerService_Factory() { return new NautikoWSScannerService(i0.ɵɵinject(i1.HttpClient)); }, token: NautikoWSScannerService, providedIn: "root" });
